import moment from "moment-timezone";

class TimeZoneHandler {
static convertTime  (utcDateString) {
  const userTimeZone = moment.tz.guess();
  const convertedDate = moment.utc(utcDateString).tz(userTimeZone);

  const formattedDate = convertedDate.format("MMMM D, YYYY h:mm:ss a");

  return formattedDate;
  }

  static convertTimeByUserLocation(utcDateString) {
    
    const userTimeZone = moment.tz.guess();
  
    const utcDateTime = moment.utc(utcDateString, "YYYY-MM-DD HH:mm:ss.SSSSSS");

    const convertedDate = utcDateTime.clone().tz(userTimeZone);

    const formattedDate = convertedDate.format("YYYY-MM-DD HH:mm:ss.SSSSSS");

    return formattedDate;
  }

  static convertTimeToCustomFormat(utcDateString) {
    const userTimeZone = moment.tz.guess();
    const convertedDate = moment.utc(utcDateString).tz(userTimeZone);

    // Format the date as "DD-MM-YYYY h:mm:ss A"
    const formattedDate = convertedDate.format("DD-MM-YYYY h:mm:ss A");

    return formattedDate;
  }

  static formatDateToYYYYMMDDHHmm = (date) => {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:00.000`;
  };

}

export default TimeZoneHandler;
